"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUniqueId = void 0;
var react_1 = require("react");
var generateId_1 = require("../util/generateId");
var useUniqueId = function () {
    var id = (0, react_1.useRef)((0, generateId_1.generateId)());
    return id;
};
exports.useUniqueId = useUniqueId;
//# sourceMappingURL=useUniqueId.js.map